/* ORTA theme behaviour: cart drawer, bundle selector, gallery, reveal, popup */
(function () {
  var money = function (cents) {
    var fmt = window.ORTA_MONEY_FORMAT || '{{amount}}';
    var v = (cents / 100).toFixed(2);
    if (fmt.indexOf('amount_with_comma_separator') > -1 || fmt.indexOf('with_comma_separator') > -1) {
      v = v.replace('.', ',');
      v = v.replace(/\B(?=(\d{3})+(?!\d)(?=,))/g, '.');
    }
    return fmt.replace(/{{\s*\w+\s*}}/, v);
  };
  window.ortaMoney = money;

  /* ---------- reveal on scroll ---------- */
  function initReveal(root) {
    var scope = root || document;
    scope.querySelectorAll('.sect > .wrap > *, .hero > *, .mega__feature').forEach(function (el) {
      if (!el.closest('.drawer') && !el.classList.contains('reveal')) el.classList.add('reveal');
    });
    scope.querySelectorAll('.grid > *').forEach(function (el) {
      if (!el.closest('.drawer') && !el.classList.contains('reveal')) el.classList.add('reveal');
    });
    var maxH = window.innerHeight * 0.62;
    scope.querySelectorAll('.reveal:not(.is-in):not([data-split])').forEach(function (el) {
      if (el.getBoundingClientRect().height <= maxH) return;
      var kids = [].slice.call(el.children);
      if (kids.length < 2) return;
      el.setAttribute('data-split', '');
      el.classList.add('is-in');
      var side = el.classList.contains('reveal--side');
      kids.slice(0, 10).forEach(function (k, i) {
        k.classList.add('reveal');
        if (side) k.classList.add('reveal--side');
        k.style.transitionDelay = Math.min(i, 6) * 60 + 'ms';
      });
    });

    var els = scope.querySelectorAll('.reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    var above = 0;
    els.forEach(function (e) {
      if (e.getBoundingClientRect().top < window.innerHeight * 0.94) {
        var d = Math.min(above, 5) * 60;
        above++;
        if (d) setTimeout(function () { e.classList.add('is-in'); }, d);
        else e.classList.add('is-in');
      } else {
        io.observe(e);
      }
    });
  }

  /* ---------- rotating announcement bar ---------- */
  function initAnnounce(root) {
    (root || document).querySelectorAll('[data-announce]').forEach(function (bar) {
      if (bar.__timer) clearInterval(bar.__timer);
      var slides = bar.querySelectorAll('[data-announce-slide]');
      if (slides.length < 2) return;
      var i = 0;
      var wait = parseInt(bar.getAttribute('data-interval'), 10) || 4000;
      bar.__timer = setInterval(function () {
        var cur = slides[i];
        i = (i + 1) % slides.length;
        cur.classList.remove('is-on');
        cur.classList.add('is-out');
        slides[i].classList.remove('is-out');
        slides[i].classList.add('is-on');
        setTimeout(function () { cur.classList.remove('is-out'); }, 500);
      }, wait);
    });
  }

  /* ---------- cart drawer ---------- */
  var Cart = {
    open: function () {
      if (!document.querySelector('.drawer')) return Promise.resolve();
      return Cart.refresh().then(function () {
        document.body.classList.add('drawer-open');
        var c = document.querySelector('.drawer__close'); if (c) c.focus();
      });
    },
    close: function () { document.body.classList.remove('drawer-open'); },
    refresh: function () {
      return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + '?section_id=cart-drawer' : '/?section_id=cart-drawer'), { cache: 'no-store' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-drawer-content]');
          var cur = document.querySelector('[data-cart-drawer-content]');
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
          var count = doc.querySelector('[data-cart-count]');
          document.querySelectorAll('[data-cart-count]').forEach(function (el) { if (count) el.textContent = count.textContent; });
        });
    },
    add: function (items) {
      var btns = document.querySelectorAll('[data-atc]');
      btns.forEach(function (b) { b.disabled = true; });
      return fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json(); }).then(function () {
        return Cart.open();
      }).catch(function (e) { console.error('[ORTA] add to cart failed', e); })
        .finally(function () { btns.forEach(function (b) { b.disabled = false; }); });
    },
    change: function (line, qty) {
      return fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function () { return Cart.refresh(); });
    }
  };
  window.ORTACart = Cart;

  /* ---------- delegated events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var openBtn = t.closest('[data-cart-open]');
    if (openBtn) { e.preventDefault(); Cart.open(); return; }

    if (t.closest('[data-cart-close]') || t.closest('.drawer-backdrop')) { Cart.close(); return; }

    var qtyBtn = t.closest('[data-qty-change]');
    if (qtyBtn) {
      e.preventDefault();
      Cart.change(qtyBtn.getAttribute('data-line'), parseInt(qtyBtn.getAttribute('data-qty-change'), 10));
      return;
    }

    var quickAdd = t.closest('[data-quick-add]');
    if (quickAdd) {
      e.preventDefault();
      Cart.add([{ id: parseInt(quickAdd.getAttribute('data-quick-add'), 10), quantity: 1 }]);
      return;
    }

    var burger = t.closest('[data-burger]');
    if (burger) {
      var nav = document.querySelector('.mobile-nav');
      if (nav) { nav.classList.toggle('is-open'); burger.setAttribute('aria-expanded', nav.classList.contains('is-open')); }
      return;
    }

    var thumb = t.closest('[data-gal-thumb]');
    if (thumb) {
      var idx = thumb.getAttribute('data-gal-thumb');
      var gal = thumb.closest('[data-gallery]');
      gal.querySelectorAll('[data-gal-thumb]').forEach(function (b) { b.setAttribute('aria-current', b === thumb); });
      gal.querySelectorAll('[data-gal-slide]').forEach(function (s) {
        s.classList.toggle('is-active', s.getAttribute('data-gal-slide') === idx);
      });
      return;
    }

    var zoom = t.closest('[data-zoom]');
    if (zoom && window.matchMedia('(min-width: 750px)').matches) { zoom.classList.toggle('is-zoomed'); return; }

    var popClose = t.closest('[data-popup-close]');
    if (popClose) {
      document.querySelector('.popup-backdrop').classList.remove('is-open');
      try { localStorage.setItem('orta:popup-dismissed', '1'); } catch (err) {}
      return;
    }

    var scrollAtc = t.closest('[data-scroll-atc]');
    if (scrollAtc) {
      e.preventDefault();
      var buyForm = document.querySelector('[data-product-form]');
      if (buyForm) { buyForm.requestSubmit(); }
      else { window.location.href = scrollAtc.getAttribute('href') || '#'; }
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      Cart.close();
      var p = document.querySelector('.popup-backdrop.is-open');
      if (p) p.classList.remove('is-open');
    }
  });

  /* ---------- mega menu ---------- */
  function initMega() {
    var root = document.querySelector('[data-mega-root]');
    if (!root) return;
    var panels = root.querySelectorAll('[data-mega-panel]');
    var triggers = root.querySelectorAll('[data-mega-trigger]');

    function close() {
      panels.forEach(function (p) { p.hidden = true; });
      triggers.forEach(function (t) { if (t.hasAttribute('aria-expanded')) t.setAttribute('aria-expanded', 'false'); });
    }
    function open(id) {
      close();
      var panel = root.querySelector('[data-mega-panel="' + id + '"]');
      if (!panel) return;
      panel.hidden = false;
      var trig = root.querySelector('[data-mega-trigger="' + id + '"]');
      if (trig) trig.setAttribute('aria-expanded', 'true');
    }

    triggers.forEach(function (t) {
      var id = t.getAttribute('data-mega-trigger');
      t.addEventListener('mouseenter', function () { id === 'none' ? close() : open(id); });
      t.addEventListener('focus', function () { id === 'none' ? close() : open(id); });
    });
    root.addEventListener('mouseleave', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    root.__megaClose = close;
  }

  /* ---------- product form: bundle + FBT ---------- */
  function initProductForm() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;
    var idInput = form.querySelector('[data-variant-id]');
    var qtyInput = form.querySelector('[data-variant-qty]');

    function syncFromBundle(input) {
      if (!input) return;
      if (idInput) idInput.value = input.value;
      if (qtyInput) qtyInput.value = input.getAttribute('data-qty') || 1;
      var price = input.getAttribute('data-price');
      var was = input.getAttribute('data-compare');
      document.querySelectorAll('[data-atc-price]').forEach(function (el) { el.textContent = money(parseInt(price, 10)); });
      document.querySelectorAll('[data-atc-was]').forEach(function (el) {
        if (was && parseInt(was, 10) > parseInt(price, 10)) { el.textContent = money(parseInt(was, 10)); el.style.display = ''; }
        else { el.style.display = 'none'; }
      });
      document.querySelectorAll('[data-atc-title]').forEach(function (el) { el.textContent = input.getAttribute('data-title') || ''; });
    }

    var extraCount = 0;

    function unitPrice(selected) {
      if (!selected) return 0;
      var qty = parseInt(selected.getAttribute('data-qty') || '1', 10) || 1;
      return Math.round(parseInt(selected.getAttribute('data-price'), 10) / qty);
    }

    function syncTotals() {
      if (!form.querySelector('[data-bundle-input]')) return;
      var selected = form.querySelector('[data-bundle-input]:checked');
      var base = selected ? parseInt(selected.getAttribute('data-price'), 10) : 0;
      var baseOld = selected ? parseInt(selected.getAttribute('data-compare'), 10) : 0;
      var addOn = 0, addOnOld = 0, count = 0;
      form.querySelectorAll('[data-addon-price]').forEach(function (cb) {
        if (!cb.checked) return;
        count++;
        addOn += parseInt(cb.getAttribute('data-addon-price'), 10) || 0;
        addOnOld += parseInt(cb.getAttribute('data-addon-old'), 10) || 0;
      });
      var unit = unitPrice(selected);
      var extraSum = unit * extraCount;
      var extraOld = (parseInt((selected && selected.getAttribute('data-compare')) || '0', 10) / (parseInt((selected && selected.getAttribute('data-qty')) || '1', 10) || 1)) * extraCount;
      var uEl = form.querySelector('[data-extra-unit]');
      if (uEl) uEl.textContent = money(unit);
      var eEl = form.querySelector('[data-extra-total]');
      if (eEl) eEl.textContent = extraCount ? '+ ' + money(extraSum) : '';
      var cEl = form.querySelector('[data-extra-count]');
      if (cEl) cEl.textContent = extraCount;
      var pEl = form.querySelector('[data-extra-prop]');
      if (pEl) pEl.value = extraCount ? extraCount + ' zusätzliche Karten' : '';

      var total = base + extraSum + addOn, totalOld = baseOld + Math.round(extraOld) + addOnOld;
      var now = form.querySelector('[data-total-now]');
      var was = form.querySelector('[data-total-was]');
      var cnt = form.querySelector('[data-addon-count]');
      if (now) now.textContent = money(total);
      if (was) { if (totalOld > total) { was.textContent = money(totalOld); was.style.display = ''; } else { was.style.display = 'none'; } }
      if (cnt) cnt.textContent = count;
      var cw = form.querySelector('[data-addon-word]');
      if (cw) cw.textContent = count === 1 ? 'Extra' : 'Extras';
      var save = form.querySelector('[data-addon-savings]');
      if (save) {
        var diff = addOnOld - addOn;
        save.style.display = diff > 0 ? 'flex' : 'none';
        var v = save.querySelector('[data-addon-savings-value]');
        if (v) v.textContent = '−' + money(diff);
      }
      document.querySelectorAll('[data-atc-price]').forEach(function (el) { el.textContent = money(total); });
      document.querySelectorAll('[data-atc-was]').forEach(function (el) {
        if (totalOld > total) { el.textContent = money(totalOld); el.style.display = ''; } else { el.style.display = 'none'; }
      });
    }

    form.querySelectorAll('[data-bundle-input]').forEach(function (input) {
      input.addEventListener('change', function () { syncFromBundle(input); syncTotals(); });
    });
    form.querySelectorAll('[data-addon-price]').forEach(function (cb) {
      cb.addEventListener('change', syncTotals);
    });
    form.querySelectorAll('[data-simple-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var out = form.querySelector('[data-simple-qty-value]');
        var v = Math.max(1, Math.min(20, parseInt(out.textContent, 10) + parseInt(btn.getAttribute('data-simple-qty'), 10)));
        out.textContent = v;
        if (qtyInput) qtyInput.value = v;
      });
    });
    form.querySelectorAll('[data-extra-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        extraCount = Math.max(0, Math.min(20, extraCount + parseInt(btn.getAttribute('data-extra-step'), 10)));
        syncTotals();
      });
    });
    syncFromBundle(form.querySelector('[data-bundle-input]:checked'));
    syncTotals();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var items = [];
      var selected = form.querySelector('[data-bundle-input]:checked');
      if (selected) {
        items.push({ id: parseInt(selected.value, 10), quantity: parseInt(selected.getAttribute('data-qty') || '1', 10) });
      } else if (idInput) {
        items.push({ id: parseInt(idInput.value, 10), quantity: parseInt((qtyInput && qtyInput.value) || '1', 10) });
      }
      if (extraCount > 0 && selected) {
        items.push({
          id: parseInt(selected.value, 10),
          quantity: extraCount,
          properties: { 'Zusatzkarten': extraCount + ' × einzeln ergänzt' }
        });
      }
      form.querySelectorAll('[data-fbt]:checked').forEach(function (cb) {
        items.push({ id: parseInt(cb.value, 10), quantity: 1 });
      });
      Cart.add(items).then(function () { extraCount = 0; syncTotals(); });
    });

    var sticky = document.querySelector('[data-sticky-atc]');
    var anchor = document.querySelector('[data-atc-anchor]');
    if (sticky && anchor) {
      var footer = document.querySelector('.ftr, footer');
      var update = function () {
        var past = anchor.getBoundingClientRect().bottom < 0;
        if (past && footer) {
          past = footer.getBoundingClientRect().top >= window.innerHeight - 40;
        }
        if (past) sticky.hidden = false;
        sticky.classList.toggle('is-visible', past);
      };
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
  }

  /* ---------- recently viewed ---------- */
  function trackRecentlyViewed() {
    var el = document.querySelector('[data-recently-viewed]');
    var handle = document.body.getAttribute('data-product-handle');
    var key = 'orta:recently-viewed';
    var list = [];
    try { list = JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) {}
    if (handle) {
      list = [handle].concat(list.filter(function (h) { return h !== handle; })).slice(0, 8);
      try { localStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
    }
    if (!el) return;
    var show = list.filter(function (h) { return h !== handle; }).slice(0, 4);
    if (!show.length) { el.remove(); return; }
    Promise.all(show.map(function (h) {
      return fetch('/products/' + h + '?section_id=recently-viewed-card')
        .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (parts) {
      var target = el.querySelector('[data-recently-viewed-grid]');
      var html = parts.map(function (p) {
        if (!p) return '';
        var doc = new DOMParser().parseFromString(p, 'text/html');
        var card = doc.querySelector('.pcard');
        return card ? card.outerHTML : '';
      }).join('');
      if (!html.trim()) { el.remove(); return; }
      target.innerHTML = html;
      el.hidden = false;
    });
  }

  /* ---------- exit-intent / delayed popup ---------- */
  function initPopup() {
    var pop = document.querySelector('.popup-backdrop');
    if (!pop) return;
    var dismissed = false;
    try { dismissed = localStorage.getItem('orta:popup-dismissed') === '1'; } catch (e) {}
    if (dismissed) return;
    var shown = false;
    function show() { if (shown) return; shown = true; pop.classList.add('is-open'); }
    var delay = parseInt(pop.getAttribute('data-delay') || '15', 10);
    if (delay > 0) setTimeout(show, delay * 1000);
    document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY < 10) show(); });
  }

  /* ---------- stock/urgency bar: randomized, not tied to real inventory ---------- */
  function initFakeStock(root) {
    (root || document).querySelectorAll('[data-stock]').forEach(function (el) {
      var threshold = parseInt(el.getAttribute('data-stock-threshold'), 10) || 50;
      var max = parseInt(el.getAttribute('data-stock-max'), 10) || 150;
      var min = Math.max(3, Math.floor(threshold * 0.15));
      var n = Math.floor(Math.random() * (threshold - min + 1)) + min;
      var fill = el.querySelector('[data-stock-fill]');
      if (fill) {
        var w = Math.round(n / max * 100);
        fill.style.width = Math.max(6, Math.min(100, w)) + '%';
      }
      var lbl = el.querySelector('[data-stock-label]');
      if (lbl) {
        var tmpl = lbl.getAttribute('data-template');
        if (tmpl) lbl.textContent = tmpl.replace('{{ count }}', n);
      }
    });
  }

  function init() {
    initAnnounce(document);
    initReveal(document);
    initMega();
    initProductForm();
    trackRecentlyViewed();
    initPopup();
    initFakeStock();
  }

  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);

  /* theme editor support */
  document.addEventListener('shopify:section:load', function (e) { initAnnounce(e.target); initReveal(e.target); initMega(); initProductForm(); initFakeStock(e.target); });
})();

/* localization: submit on change, no extra button */
(function () {
  document.querySelectorAll('[data-loc-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var form = sel.closest('form');
      if (!form) return;
      var input = form.querySelector('[data-loc-input]');
      if (input) input.value = sel.value;
      form.submit();
    });
  });
})();

/* horizontal rails with prev/next buttons */
(function () {
  document.querySelectorAll('.rev__head').forEach(function (head) {
    var sect = head.closest('section');
    if (!sect) return;
    var rail = sect.querySelector('[data-rail]');
    if (!rail) return;
    function step(dir) {
      var card = rail.querySelector('.card');
      var w = (card ? card.offsetWidth : 370) + 20;
      rail.scrollBy({ left: dir * w * 2, behavior: 'smooth' });
    }
    var p = head.querySelector('[data-rail-prev]');
    var n = head.querySelector('[data-rail-next]');
    if (p) p.addEventListener('click', function () { step(-1); });
    if (n) n.addEventListener('click', function () { step(1); });
  });
})();

/* video review stories */
(function () {
  var modal = document.querySelector('[data-vstory-modal]');
  if (!modal) return;
  var video = modal.querySelector('[data-vstory-video]');
  var ph = modal.querySelector('[data-vstory-ph]');
  var nameEl = modal.querySelector('[data-vstory-modal-name]');
  var textEl = modal.querySelector('[data-vstory-modal-text]');

  function close() {
    modal.hidden = true;
    video.pause();
    video.removeAttribute('src');
    document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-vstory]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var src = btn.getAttribute('data-vstory-src');
      nameEl.textContent = btn.getAttribute('data-vstory-name') || '';
      textEl.textContent = btn.getAttribute('data-vstory-text') || '';
      if (src) {
        video.hidden = false; ph.hidden = true;
        video.src = src;
        var p = video.play(); if (p && p.catch) p.catch(function () {});
      } else {
        video.hidden = true; ph.hidden = false;
        ph.textContent = btn.getAttribute('data-vstory-label') || 'ugc-video · hochformat';
      }
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    });
  });
  modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
  var closeBtn = modal.querySelector('[data-vstory-close]');
  if (closeBtn) closeBtn.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
})();

/* cart extras: warranty / gift wrap checkboxes */
document.addEventListener('change', function (e) {
  var box = e.target.closest('[data-extra-toggle]');
  if (!box || !window.ORTACart) return;
  var id = Number(box.getAttribute('data-extra-toggle'));
  box.disabled = true;
  var done = function () { box.disabled = false; };
  if (box.checked) {
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function () { return window.ORTACart.refresh(); }).then(done, done);
  } else {
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: String(id), quantity: 0 })
    }).then(function () { return window.ORTACart.refresh(); }).then(done, done);
  }
});

/* review image lightbox */
(function () {
  var modal = document.querySelector('[data-rev-modal]');
  if (!modal) return;
  var img = modal.querySelector('[data-rev-modal-img]');
  var ph = modal.querySelector('[data-rev-modal-ph]');
  var label = modal.querySelector('[data-rev-modal-label]');
  var who = modal.querySelector('[data-rev-modal-name]');
  var link = modal.querySelector('[data-rev-modal-link]');

  function close() { modal.hidden = true; document.body.style.overflow = ''; }

  document.querySelectorAll('[data-rev-zoom]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var src = btn.getAttribute('data-rev-src');
      var href = btn.getAttribute('data-rev-link');
      label.textContent = btn.getAttribute('data-rev-label') || '';
      who.textContent = btn.getAttribute('data-rev-name') || '';
      if (src) { img.src = src; img.alt = label.textContent; img.hidden = false; ph.hidden = true; }
      else { img.hidden = true; ph.hidden = false; ph.textContent = 'ugc-foto · ' + label.textContent.toLowerCase() + ' im einsatz'; }
      if (href) { link.href = href; link.hidden = false; } else { link.hidden = true; }
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    });
  });
  modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
  var c = modal.querySelector('[data-rev-close]');
  if (c) c.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
})();

/* mobile search toggle */
(function () {
  var panel = document.querySelector('[data-mobile-search]');
  if (!panel) return;
  function setToggles(open) {
    document.querySelectorAll('[data-search-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
  }
  function open() {
    panel.hidden = false;
    setToggles(true);
    var input = panel.querySelector('.mobile-search__input');
    if (input) setTimeout(function () { input.focus(); }, 10);
  }
  function close() {
    panel.hidden = true;
    setToggles(false);
  }
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-search-toggle]');
    if (toggle && window.matchMedia('(max-width: 1023px)').matches) {
      e.preventDefault();
      if (panel.hidden) open(); else close();
      return;
    }
    if (e.target.closest('[data-search-close]')) { close(); return; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) close(); });
})();

/* header language/country switcher: render as a flag circle */
(function () {
  function flagFromIso(code) {
    if (!code) return '';
    var cc = code.trim().toUpperCase();
    var map = { EN: 'GB' };
    var base = cc.split('-')[0];
    var iso = map[base] || base;
    if (iso.length !== 2) iso = iso.slice(0, 2);
    return String.fromCodePoint.apply(null, iso.split('').map(function (c) { return 127397 + c.charCodeAt(0); }));
  }
  document.querySelectorAll('[data-loc-flag]').forEach(function (el) {
    el.textContent = flagFromIso(el.getAttribute('data-loc-flag'));
  });
})();

/* generic dots for slideable/swipeable segments (mobile) */
(function () {
  function attachDots(rail, opts) {
    opts = opts || {};
    var items = [].slice.call(rail.children);
    if (items.length < 2) return null;
    var dots = document.createElement('div');
    dots.className = 'rail-dots';
    items.forEach(function (item, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'rail-dots__dot';
      if (i === 0) b.classList.add('is-active');
      b.setAttribute('aria-label', 'Zu Element ' + (i + 1));
      b.addEventListener('click', function () {
        if (opts.onDot) { opts.onDot(i); return; }
        item.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
      dots.appendChild(b);
    });
    (opts.after || rail).insertAdjacentElement('afterend', dots);
    if (!opts.onDot) {
      var ticking = false;
      rail.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var center = rail.scrollLeft + rail.clientWidth / 2;
          var closest = 0, min = Infinity;
          items.forEach(function (item, i) {
            var mid = item.offsetLeft + item.offsetWidth / 2;
            var d = Math.abs(mid - center);
            if (d < min) { min = d; closest = i; }
          });
          dots.querySelectorAll('.rail-dots__dot').forEach(function (d, i) { d.classList.toggle('is-active', i === closest); });
          ticking = false;
        });
      });
    }
    return dots;
  }

  document.querySelectorAll('.rail--mobile, .rev__rail, .vstories__rail, .buybox-stories__rail, .gal__main').forEach(function (rail) {
    attachDots(rail);
  });
})();

/* comparison table: swipe hint, fades on first scroll */
(function () {
  document.querySelectorAll('.cmp').forEach(function (cmp) {
    if (cmp.scrollWidth <= cmp.clientWidth + 4) return;
    var hint = document.createElement('div');
    hint.className = 'cmp-hint';
    hint.innerHTML = '<span class="cmp-hint__icon" aria-hidden="true">&#8596;</span><span>Wischen zum Vergleichen</span>';
    cmp.appendChild(hint);
    cmp.addEventListener('scroll', function () { hint.classList.add('is-hidden'); }, { once: true });
  });
})();
